<div class="bk-breadcrumb bk-container">
  <a routerLink="/">Home</a>
  <app-icon name="chevron-right" [size]="14" />
  <span>Booking Confirmed</span>
</div>

<div class="bk-page">
  <div class="bk-container--narrow">
    @if (loading()) {
      <div class="bk-state">
        <app-icon name="loader-circle" [size]="32" className="bk-spin" />
        <p>Loading your booking&hellip;</p>
      </div>
    } @else if (error()) {
      <div class="bk-state">
        <p class="bk-error">{{ error() }}</p>
        <a routerLink="/my-trips" class="bk-btn bk-btn--ghost">View My Trips</a>
      </div>
    } @else if (tickets().length > 0) {
      @if (paymentProblem()) {
        <div class="confirm__hero">
          <h1 class="confirm__title">Payment needed</h1>
          <p class="confirm__subtitle">{{ paymentProblem() }}</p>
          @if (resumeReference()) {
            <button type="button" class="bk-btn bk-btn--primary" (click)="retryPayment()">
              Continue to Starpay
            </button>
          }
        </div>
      } @else {
      <div class="confirm__hero">
        <div class="confirm__check">
          <app-icon name="circle-check" [size]="40" />
        </div>
        <h1 class="confirm__title">Booking Confirmed!</h1>
        <p class="confirm__subtitle">Your e-ticket has been sent to your email and phone.</p>
        <p class="confirm__note">
          You can also print your ticket at any terminal counter using the booking code below.
        </p>
      </div>
      }

      @for (ticket of tickets(); track ticket.booking.referenceCode) {
        <div class="bk-card confirm__ticket" id="eticket">
          @if (tickets().length > 1) {
            <p class="confirm__leg">{{ ticket.label }}</p>
          }
          <p class="confirm__ref-label">BOOKING REFERENCE</p>
          <p class="confirm__ref">{{ ticket.booking.referenceCode }}</p>

          <div class="confirm__qr">
            @if (ticket.qrDataUrl) {
              <img [src]="ticket.qrDataUrl" alt="Booking QR code" />
            } @else {
              <div class="confirm__qr-fallback"><app-icon name="qr-code" [size]="64" /></div>
            }
            <span>Show this QR code to the conductor</span>
          </div>

          <div class="confirm__ticket-head">
            <div class="confirm__ticket-route">
              <app-icon name="bus" [size]="18" />
              <div>
                <strong>{{ ticket.routeLabel }}</strong>
                @if (ticket.booking.busTypeName) {
                  <p>{{ ticket.booking.busTypeName }}</p>
                }
              </div>
            </div>
            <span class="confirm__status">{{ ticket.booking.status | titlecase }}</span>
          </div>

          <div class="confirm__facts">
            <div>
              <app-icon name="calendar" [size]="16" />
              <span class="confirm__fact-label">Date</span>
              <strong>{{ ticket.dateLabel }}</strong>
            </div>
            <div>
              <app-icon name="clock" [size]="16" />
              <span class="confirm__fact-label">Departure</span>
              <strong>{{ ticket.departureTime || '—' }}</strong>
            </div>
            <div>
              <app-icon name="map-pin" [size]="16" />
              <span class="confirm__fact-label">Terminal</span>
              <strong>{{ ticket.terminal || '—' }}</strong>
            </div>
          </div>

          <div class="confirm__rows">
            <div class="confirm__row">
              <span>Seats</span>
              <span>{{ ticket.seatLabels }}</span>
            </div>
            <div class="confirm__row">
              <span>Passenger</span>
              <span>{{ ticket.booking.passengerFirstName }} {{ ticket.booking.passengerLastName }}</span>
            </div>
            <div class="confirm__row">
              <span>Payment</span>
              <span>{{ ticket.paymentLabel }}</span>
            </div>
            <div class="confirm__row confirm__row--total">
              <span>Total Paid</span>
              <span>{{ formatCurrency(ticket.booking.totalAmount) }}</span>
            </div>
          </div>
        </div>
      }

      <div class="bk-card confirm__delivery">
        <h2 class="confirm__delivery-title">Your E-Ticket Has Been Sent</h2>
        <ul>
          <li>
            <app-icon name="mail" [size]="16" />
            <span><strong>Email:</strong> E-ticket with QR code sent to your registered email.</span>
          </li>
          <li>
            <app-icon name="smartphone" [size]="16" />
            <span>
              <strong>SMS:</strong> Booking code
              {{ tickets()[0].booking.referenceCode }}
              @if (tickets().length > 1) {
                / {{ tickets()[1].booking.referenceCode }}
              }
              sent to your phone number.
            </span>
          </li>
          <li>
            <app-icon name="printer" [size]="16" />
            <span><strong>Print at Terminal:</strong> Show your booking code at any counter to get a printed ticket.</span>
          </li>
        </ul>
      </div>

      <div class="confirm__actions">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="download()">
          <app-icon name="download" [size]="16" />
          <span>Download E-Ticket</span>
        </button>
        <a routerLink="/" class="bk-btn bk-btn--primary">Book Another Trip</a>
      </div>

      <p class="confirm__footer">
        Please arrive at the terminal at least 30 minutes before departure. Present your QR code,
        booking reference, or printed ticket to the conductor.
      </p>
    }
  </div>
</div>
